export default {
  CATEGORY: 'category',
};
